import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { COLOR_PRIMARY_2, WATER_MARK_COLOR } from 'src/colors';
import LockIcon from '@mui/icons-material/Lock';

const DisabledBlurCard = ({
  size,
  subscriptionType,
  onDisabledOptionClick,
}: {
  size?: number;
  subscriptionType: 'Pro' | 'Expert';
  onDisabledOptionClick?: () => void;
}) => {
  return (
    <Box      
      sx={{
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        zIndex: 1000,
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {/* <Typography
        variant="body1"
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer',
          fontWeight: 'bold',
          fontSize: size ? `${size}px` : '16px',
          color: WATER_MARK_COLOR,
          '&:hover': {
            textDecoration: 'underline',
          },
        }}
      >
        <LockIcon sx={{ color: WATER_MARK_COLOR, marginRight: '10px', fontSize: size ? `${size}px` : '16px' }} />
        Subscribe to {subscriptionType}
      </Typography> */}
      <Button
        sx={{
          background: 'transparent',
          marginLeft: '-4px',
          fontSize: '20px',
          fontWeight: 500,
          color: COLOR_PRIMARY_2,
          cursor: 'pointer',
          pointerEvents: 'auto',
          textDecoration: 'underline',
        }}
        onClick={() => onDisabledOptionClick && onDisabledOptionClick()}
      >
        Upgrade to {subscriptionType}
      </Button>
    </Box>
  );
};

export default DisabledBlurCard;
